import { useContext } from "react";
import { store } from "../components/Store";

/**
 * Hook para obtener el lenguaje de la app
 * @returns {string} language
 */
export const useLanguage = () => {
	const { state } = useContext(store);
    const globalLang = state?.language || "es";

	return globalLang;
};
